import { snake } from 'change-case'
import { api } from '../../libs/api'
import pagination from './pagination'

export default {
  namespaced: true,

  modules: {
    pagination: pagination(),
  },

  state: {
    index: [],
    detail: {},
    companyIds: new Set([]),
    modal: {
      show: false,
    },
    onMarking: 0,
  },
  getters: {
    index: state => state.index,
    companyIds: state => state.companyIds,
    companyIdsCount: (state) => {
      const ids = state.companyIds
      // eslint-disable-next-line no-nested-ternary
      const count = Array.isArray(ids) ? ids.length
        : (ids && typeof ids.size === 'number' ? ids.size : 0)
      if (count > 0) return count
      return Array.isArray(state.index) ? state.index.length : 0
    },
    AllJobMarkModal: state => state.modal.show,
    onMarking: state => state.onMarking,
  },
  mutations: {
    index: (state, index) => state.index = index,
    detail: (state, detail) => state.detail = detail,
    changeJobMark: (state, { value, companyId, user }) => {
      const company = state.index.find(d => d.company_id === companyId)
      company.in_job_mark = value
      company.job_mark_user = user.name
    },
    copyCompanyIds: (state, ids) => {
      const safeIds = Array.isArray(ids) ? ids.filter(Boolean) : []
      state.companyIds = new Set(safeIds)
    },
    openModal: state => state.modal.show = true,
    hideModal: state => state.modal.show = false,
    onMarking: (state, onMarking) => state.onMarking = onMarking,
    setOnMarkingStart: state => state.onMarking = 0,
    setOnMarking: state => state.onMarking = 1,
    setOnMarkingEnd: state => state.onMarking = 2,
  },
  actions: {
    async fetchIndex ({ commit }, query) {
      try {
        const requestParameters = Object.keys(query).reduce((acc, key) => {
          acc[snake(key)] = query[key]
          return acc
        }, {})
        const { meta, index } = await api.fetchCompanies(requestParameters)
        commit('pagination/newState', meta)
        commit('index', index)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async fetchDetail ({ commit }, { id }) {
      try {
        const response = await api.fetchCompany(id)
        commit('detail', response[0])
      } catch (e) {
        return Promise.reject(e)
      }
    },
    downloadCompaniesCsv ({ state: { companyIds } }, { allColumns }) {
      if (companyIds.size === 0) {
        return
      }
      return api.downloadCompaniesCsv(companyIds, allColumns)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/map.js